import BigNumber from 'bignumber.js'
import React, { useEffect, useState } from 'react'
import { useInfo24H } from '../../../hooks/trade/info24H'
import { useTradeStore } from '../../../hooks/trade/tradeStore'
import DefaultKrw from './DefaultKrw'

const HighPrice = () => {
	const { symbol, dp } = useTradeStore()
	const { data, getinfo24, refresh } = useInfo24H(symbol)

	const [high, setHigh] = useState<any>(getinfo24(symbol)?.high)

	const info24 = getinfo24(symbol)
	const beforeclose = BigNumber(info24?.open).minus(info24?.change).toNumber()

	useEffect(() => {
		setHigh(getinfo24(symbol)?.high)
	}, [refresh, data])

	return (
		<DefaultKrw
			title={'고가'}
			price={high || 0}
			dp={dp}
			krw={false}
			color={true}
			center={true}
			comma={false}
			colordiff={
				beforeclose < info24?.high
					? 'up'
					: beforeclose > info24?.high
					? 'down'
					: 'same'
			}
		/>
	)
}

export default React.memo(HighPrice)
